import { render, staticRenderFns } from "./KeyboardCodeHandler.vue?vue&type=template&id=8a48f9fe&"
import script from "./KeyboardCodeHandler.vue?vue&type=script&lang=js&"
export * from "./KeyboardCodeHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports